import React from 'react';
import styled from 'styled-components';
import { AuthContext } from 'contexts';
import Tag from '../Tag';
import Spin from '../Spin';

const StyledChatStatusBadge = styled.span<{ $showMargin: boolean }>`
  && {
    > span {
      font-size: 14px;
      transition: background-color 0s;
      cursor: pointer;
      margin: ${({ $showMargin }) => ($showMargin ? '0 0 0 5px' : '0')};
    }
  }
`;

type ChatStatusBadgeProps = {
  showMargin?: boolean;
};

const ChatStatusBadge: React.FC<ChatStatusBadgeProps> = ({ showMargin }) => {
  const { auth, toggleChatInactive } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    await toggleChatInactive(() => setLoading(true));
    setLoading(false);
  };

  const renderProps = (): {
    children: React.ReactNode;
    color: 'white' | 'danger' | 'success';
  } => {
    if (loading)
      return {
        children: <Spin />,
        color: 'white',
      };
    if (auth?.isChatInactive)
      return {
        children: 'AWAY',
        color: 'danger',
      };
    return {
      children: 'ACTIVE',
      color: 'success',
    };
  };

  return (
    <StyledChatStatusBadge $showMargin={showMargin}>
      <Tag {...renderProps()} onClick={handleClick} />
    </StyledChatStatusBadge>
  );
};

export default ChatStatusBadge;
